export default __webpack_public_path__ + "static/edu-7a3753280f3479cdefc284b0d4ce0d18.png";